import classnames from 'classnames'
import kebabCase from 'lodash.kebabcase'
import {
  AnalyticsEvent,
  googleTagManagerCustomEvents,
  triggerGoogleTagManagerCustomEvent,
} from 'marketing-site/src/library/utils'
import React, { useEffect, useState } from 'react'

interface IProps {
  wistiaId: string
  thumbnail: string | undefined | null
  title: string
  slug: string
}

export function WebinarHeroVideo({ wistiaId, thumbnail, title, slug }: IProps) {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    setTimeout(() => setVisible(true), 200)

    const analyticsEvent = new AnalyticsEvent({
      context: 'webinar',
      action: 'played',
      object: 'wistia_video',
      metadata: { slug, wistiaId },
    })
    analyticsEvent.setPlaceFromPath(window.location.pathname)
    analyticsEvent.send()

    triggerGoogleTagManagerCustomEvent(googleTagManagerCustomEvents.playWebinarVideo)
  }, [])

  const videoClassNames = classnames('webinars__hero-video', {
    'webinars__hero-video--visible': visible,
  })

  return (
    <div className="webinars__hero-video-wrap" data-testid={`webinar-video-${kebabCase(title)}`}>
      <div className={videoClassNames} style={{ backgroundImage: `url(${thumbnail})` }}>
        <iframe
          src={`https://fast.wistia.net/embed/iframe/${wistiaId}?videoFoam=true&autoPlay=true&videoQuality=hd-only`}
          title={`Webinar Video on ${title}`}
          name="wistia_embed"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  )
}
